export const IconProductDropsMolecule = () => {
  return (
    <>
      <div className="w-full mt-7 lg:w-93/100 max-w-full hidden lg:block">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
          viewBox="0 0 459.349 280.988"
        >
          <text
            id="that_support_the_eye_s_own_ability_to_heal_itself."
            data-name="that support the eye’s own ability to heal itself."
            transform="translate(287.935 211.5)"
            fill="#fff"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="14">
              that support the eye’s own{' '}
            </tspan>
            <tspan x="0" y="33">
              ability to heal itself.
            </tspan>
          </text>
          <text
            id="No_harsh_vasoconstrictors"
            data-name="No harsh vasoconstrictors"
            transform="translate(335.349 62.5)"
            fill="#fff"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="14">
              No harsh{' '}
            </tspan>
            <tspan x="0" y="33">
              vasoconstrictors
            </tspan>
          </text>
          <text
            id="Made_with_100_natural_active_ingredients"
            data-name="Made with 100%
natural active ingredients"
            transform="translate(287.935 186.531)"
            fill="#fff"
            className="waldo-sans text-sm"
          >
            <tspan x="0" y="0" className="font-medium waldo-sans">
              Made with 100%{' '}
            </tspan>
            <tspan x="0" y="19" className="font-medium waldo-sans">
              natural active ingredients
            </tspan>
          </text>
          <path
            id="Path_419"
            data-name="Path 419"
            d="M2302.991,4370.294h-148.5"
            transform="translate(-1866.057 -4205.098)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_420"
            data-name="Path 420"
            d="M0,0V280.667"
            transform="translate(216.739)"
            fill="none"
            stroke="#fff"
            strokeWidth="1"
            strokeDasharray="1"
          />
          <path
            id="Path_421"
            data-name="Path 421"
            d="M0,0V280.667"
            transform="translate(252.501 0.321)"
            fill="none"
            stroke="#fe5000"
            strokeWidth="2"
            strokeDasharray="1"
          />
          <path
            id="Path_422"
            data-name="Path 422"
            d="M0,0V280.667"
            transform="translate(180.976 0.321)"
            fill="none"
            stroke="#fe5000"
            strokeWidth="2"
            strokeDasharray="1"
          />
          <text
            id="Compatible_with_contact_lenses"
            data-name="Compatible with
contact lenses"
            transform="translate(2.001 149.531)"
            fill="#fff"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="0">
              Compatible with
            </tspan>
            <tspan x="0" y="19">
              contact lenses
            </tspan>
          </text>
          <text
            id="Premium_Swiss_quality"
            data-name="Premium Swiss
quality"
            transform="translate(0 39.75)"
            fill="#fff"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="0" className="waldo-sans font-light text-sm">
              Premium{' '}
            </tspan>
            <tspan y="0" className="waldo-sans font-medium">
              Swiss
            </tspan>
            <tspan className="waldo-sans font-medium">
              <tspan x="0" y="19">
                quality
              </tspan>
            </tspan>
          </text>
          <path
            id="Path_423"
            data-name="Path 423"
            d="M2192.659,4370.294h-38.168"
            transform="translate(-2047.446 -4327.394)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_424"
            data-name="Path 424"
            d="M2192.619,4370.294h-38.128"
            transform="translate(-1866.057 -4292.74)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_425"
            data-name="Path 425"
            d="M2192.659,4370.294h-38.168"
            transform="translate(-2047.445 -4216.309)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <g
            id="Group_635"
            data-name="Group 635"
            transform="translate(-978.065 -4511)"
          >
            <path
              id="path1776-3-3"
              d="M219.526,264.453c0,20.739-14.756,39.339-35.763,39.339S148,285.192,148,264.453c0-25.034,35.763-67.95,35.763-67.95S219.526,239.419,219.526,264.453Z"
              transform="translate(1011.041 4476.997)"
              fill="none"
              stroke="#0057b7"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="path1776-3-3-2"
              data-name="path1776-3-3"
              d="M179.14,226.086c0,9.029-6.424,17.127-15.57,17.127S148,235.115,148,226.086c0-10.9,15.57-29.583,15.57-29.583S179.14,215.187,179.14,226.086Z"
              transform="translate(1031.234 4326.997)"
              fill="none"
              stroke="#0057b7"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="path1776-3-3-3"
              data-name="path1776-3-3"
              d="M195.436,241.568c0,13.754-9.786,26.09-23.718,26.09S148,255.322,148,241.568c0-16.6,23.718-45.065,23.718-45.065S195.436,224.965,195.436,241.568Z"
              transform="translate(1023.086 4389.997)"
              fill="none"
              stroke="#0057b7"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      </div>
      <div className="mt-7 w-full mb-5 mx-auto block lg:hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-full mx-auto"
          viewBox="-10 0 391.392 320"
        >
          <text
            id="that_support_the_eye_s_own_ability_to_heal_itself."
            data-name="that support the eye’s own ability to heal itself."
            transform="translate(220.308 183.5)"
            fill="#fff"
            className="waldo-sans font-light text-xs"
          >
            <tspan x="0" y="12">
              that support the eye’s{' '}
            </tspan>
            <tspan x="0" y="28">
              own ability to heal itself.
            </tspan>
          </text>
          <text
            id="No_harsh_vasoconstrictors"
            data-name="No harsh vasoconstrictors"
            transform="translate(267.392 35)"
            fill="#fff"
            className="waldo-sans font-light text-xs"
          >
            <tspan x="0" y="12">
              No harsh{' '}
            </tspan>
            <tspan x="0" y="28">
              vasoconstrictors
            </tspan>
          </text>
          <text
            id="Made_with_100_natural_active_ingredients"
            data-name="Made with 100%
natural active ingredients"
            transform="translate(220.308 157.591)"
            fill="#fff"
            className="waldo-sans text-xs"
          >
            <tspan x="0" y="0" className="waldo-sands font-medium">
              Made with 100%{' '}
            </tspan>
            <tspan x="0" y="16" className="font-medium waldo-sans">
              natural active ingredients
            </tspan>
          </text>
          <path
            id="Path_376"
            data-name="Path 376"
            d="M2281.092,4370.294h-126.6"
            transform="translate(-1934.183 -4235.083)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_369"
            data-name="Path 369"
            d="M0,0V320"
            transform="translate(172.5)"
            fill="none"
            stroke="#fff"
            strokeWidth="1"
            strokeDasharray="1"
          />
          <path
            id="Path_377"
            data-name="Path 377"
            d="M0,0V320"
            transform="translate(208.263)"
            fill="none"
            stroke="#fe5000"
            strokeWidth="2"
            strokeDasharray="1"
          />
          <path
            id="Path_378"
            data-name="Path 378"
            d="M0,0V320"
            transform="translate(136.737)"
            fill="none"
            stroke="#fe5000"
            strokeWidth="2"
            strokeDasharray="1"
          />
          <text
            id="Compatible_with_contact_lenses"
            data-name="Compatible with
contact lenses"
            transform="translate(2 173.091)"
            fill="#fff"
            className="waldo-sans font-light text-xs"
          >
            <tspan x="0" y="0">
              Compatible with
            </tspan>
            <tspan x="0" y="16">
              contact lenses
            </tspan>
          </text>
          <text
            id="Premium_Swiss_quality"
            data-name="Premium Swiss
quality"
            transform="translate(0 78)"
            fill="#fff"
            className="waldo-sans font-light text-xs"
          >
            <tspan x="0" y="0" className="waldo-sans font-light">
              Premium{' '}
            </tspan>
            <tspan y="0" className="waldo-sans font-medium"></tspan>
            <tspan className="waldo-sans font-medium">
              <tspan x="0" y="16">
                Swiss quality
              </tspan>
            </tspan>
          </text>
          <path
            id="Path_364"
            data-name="Path 364"
            d="M2192.659,4370.294h-38.168"
            transform="translate(-2067.967 -4288.794)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_394"
            data-name="Path 394"
            d="M2192.619,4370.294h-38.128"
            transform="translate(-1934.183 -4319.794)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_365"
            data-name="Path 365"
            d="M2192.659,4370.294h-38.168"
            transform="translate(-2067.967 -4193.703)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="path1776-3-3"
            d="M219.526,264.453c0,20.739-14.756,39.339-35.763,39.339S148,285.192,148,264.453c0-25.034,35.763-67.95,35.763-67.95S219.526,239.419,219.526,264.453Z"
            transform="translate(-11.263 -13.003)"
            fill="none"
            stroke="#0057b7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="path1776-3-3-2"
            data-name="path1776-3-3"
            d="M179.14,226.086c0,9.029-6.424,17.127-15.57,17.127S148,235.115,148,226.086c0-10.9,15.57-29.583,15.57-29.583S179.14,215.187,179.14,226.086Z"
            transform="translate(8.93 -171.003)"
            fill="none"
            stroke="#0057b7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="path1776-3-3-3"
            data-name="path1776-3-3"
            d="M195.436,241.568c0,13.754-9.786,26.09-23.718,26.09S148,255.322,148,241.568c0-16.6,23.718-45.065,23.718-45.065S195.436,224.965,195.436,241.568Z"
            transform="translate(0.781 -104.003)"
            fill="none"
            stroke="#0057b7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      </div>
    </>
  );
};
